module.exports = __webpack_public_path__ + "static/media/anmat.ac6b4a71.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/anmat.png
// module id = 110
// module chunks = 0